import React, { Component } from 'react';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import IconButton from '../../../comum/components/IconButton';
import moment from 'moment';
import { observer } from 'mobx-react';

@observer
export default class ExportExcelImportacao extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    _exporter;
    export = () => {
        this._exporter.save();
    };

    render() {
        let lista = [];
        if(this.controller.listaEntrepostagem.length > 0){
            lista = this.controller.copiaListaEntrepostagem();
        } else {
            lista = [];
        }

        let desabilita;
        if(lista.length > 0){
            desabilita = false;
        }else{
            desabilita = true;
        }

        if(lista.length > 0){
            lista.map(data => {
                const keys = Object.keys(data)
                keys.map(key =>{
                    if((key === "DtValidade" || key=== "DtAbandono") && moment(data[key]).format("DD/MM/YYYY HH:mm") !== 'Invalid date')
                        data[key] = moment(data[key]).format("DD/MM/YYYY HH:mm")
                    if(key === "IndStatus")
                        data[key] = this.controller.statusFormatter(data[key]);
                });
            });
        }

        let cols = this.controller.colunas;
        return (
            <div>
                <IconButton icon="file-excel" text="Baixar XLS" size="md" disabled={desabilita} onClick={this.export} />

                <ExcelExport
                    data={lista}
                    fileName="Relatório Sintético - Entreposto.xlsx"
                    ref={(exporter) => { this._exporter = exporter; }} >
                    { cols.map((coluna, x) => (
                        <ExcelExportColumn
                            key={x}
                            title={coluna.text}
                            field={coluna.dataField}
                        />
                    )) }
                </ExcelExport>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatoriosintetico/components/ExportExcelSintetico.js